module.exports = __webpack_public_path__ + "static/seti-contract-holder-90267d2c5792b8bc358af733cff3f22c.png";